//accordion
function accordionClick() {
  const accordion = document.getElementsByClassName('js-accordion');
  for (let i = 0; i < accordion.length; i++) {
    accordion[i].addEventListener('click', function () {
      this.classList.toggle('active');
      let parent = this.parentElement;
      let panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        parent.style.maxHeight = parseInt(parent.style.maxHeight) + panel.scrollHeight + 'px';
      }
      // console.log(this);
      // if (this.classList.contains('js-accordion--open-default')) {
      // }
    });
  }
}
accordionClick();

//defaultで開く
function accordionOpenDefault() {
  const accordion = document.getElementsByClassName('js-accordion');
  window.addEventListener('load', function () {
    for (let i = 0; i < accordion.length; i++) {
      if (accordion[i].classList.contains('js-accordion--open-default')) {
        let panel = accordion[i].nextElementSibling;
        console.log(panel);
        panel.style.maxHeight = 'initial';
        accordion[i].classList.add('active');
      }
    }
  });
}
accordionOpenDefault();

//accordion
function accordionClickSelf() {
  let menuClose = false;
  const accordionself = document.getElementsByClassName('js-accordion-self');
  for (let i = 0; i < accordionself.length; i++) {
    accordionself[i].addEventListener('click', function () {
      this.classList.toggle('active');
      let child = this.firstElementChild;
      // console.log(child);
      if (menuClose) {
        menuClose = false;
        child.classList.add('is-child-hide');
        // console.log(menuClose);
      } else {
        menuClose = true;
        child.classList.remove('is-child-hide');
        // console.log(menuClose);
      }
    });
  }
}
accordionClickSelf();
